import * as Actions from './carrier-sharing.actions';

const initialState = {
  serviceGroups: [],
  errors: [],
  isRequired: false,
  isLoading: false,
  fulfillmentPlanId: 0,
};

const actionMap = {
  [Actions.GET_SHARED_SERVICES]: (state) => {
    return {
      ...state,
      isLoading: true,
    };
  },
  [Actions.GET_SHARED_SERVICES_SUCCESS]: (state, { sharedServices, fulfillmentPlanId }) => {
    return {
      ...state,
      serviceGroups: sharedServices.serviceGroups,
      isRequired: sharedServices.required,
      isLoading: false,
      fulfillmentPlanId,
      error: undefined,
    };
  },
  [Actions.GET_SHARED_SERVICES_ERROR]: (state, { errors }) => {
    return {
      ...state,
      error: errors,
      serviceGroups: [],
      isRequired: false,
      isLoading: false,
      fulfillmentPlanId: 0,
    };
  },
};

export const reduce = (state = initialState, action = {}) => {
  const reducer = actionMap[action.type];
  if (reducer) {
    return reducer(state, action);
  }

  return state;
};

export { namespace } from './carrier-sharing.reducer.metadata';
